import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseDatatable";
import { getAllMonthlyCashSummaryRedux } from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./cash-summary.css";

export class MonthlyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllMonthlyCashSummaryRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { allMonths } = this.props;

    const uniqueMonths = [...new Set(allMonths.map((expense) => expense.month))];

    return (
      <Fragment>
        <Breadcrumb title="Cash Summary" parent="expense history" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid cs-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card cs-card">
                <div className="card-header cs-card-header">
                  <h5 className="cs-card-title">
                    <i className="icofont-bill cs-card-icon"></i>
                    Cash Summary
                  </h5>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      myData={uniqueMonths}
                      pageSize={50}
                      pagination={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allMonths: state.expenses.monthlyCashSummary,
  };
};

export default connect(mapStateToProps, {
  getAllMonthlyCashSummaryRedux,
})(MonthlyExpense);
